module.exports = __webpack_public_path__ + "static/media/icon_room.0297afa2.svg";